// @ts-nocheck
import { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { Inbox, Users, Clock, Target, Users2, UserCheck } from 'lucide-react'
import { CubeLoader } from '@/components/ui/cube-loader'
import { GET_SUMMARY } from '@/graphql/publisher-dashboard-queries'

const ICON_SIZE = 20
const ICON_CIRCLE_SIZE = 40

const PROFILE_SECTIONS = [
    { title: 'Age Group', dataIndex: 0, Icon: Inbox, iconBgColor: '#37A0E6' },
    { title: 'Family Status', dataIndex: 2, Icon: Users2, iconBgColor: '#41D8B3' },
    { title: 'Life Events', dataIndex: 4, Icon: Clock, iconBgColor: '#DC402D' },
    { title: 'Gender Group', dataIndex: 1, Icon: UserCheck, iconBgColor: '#B6581E' },
    { title: 'Interests', dataIndex: 5, Icon: Target, iconBgColor: '#AEA526' },
    { title: 'Behaviour', dataIndex: 3, Icon: Target, iconBgColor: '#2C55DB' },
]

function parseValueToList(value) {
    if (!value || value === 'In Progress...') return []
    const parts = value.split(/\)\s+/).filter(Boolean)
    return parts.map((part) => {
        if (!part.includes('(')) return part
        if (part.endsWith(')')) return part.replace(/\)$/, '%)')
        return `${part}%)`
    })
}

function ProfileCard({ title, Icon, iconBgColor, children }) {
    return (
        <div className="d-flex gap-3 h-100 p-3 rounded" style={{ maxHeight: '100px', overflow: 'auto' }}>
            <div
                className="d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle text-white"
                style={{ width: ICON_CIRCLE_SIZE, height: ICON_CIRCLE_SIZE, backgroundColor: iconBgColor }}
            >
                <Icon size={ICON_SIZE} />
            </div>
            <div className="d-flex flex-column flex-grow-1 min-w-0">
                <h6 className="small mb-2 fw-bold">{title}</h6>
                {children}
            </div>
        </div>
    )
}

const AudienceProfileReport = () => {
    const { id } = useParams()
    const [profileLines, setProfileLines] = useState([])
    const campaign = useQuery(GET_SUMMARY, {
        variables: id ? { where: { id } } : {},
        onCompleted(data) {
            const raw = data.campaigns?.[0]?.audienceProfile
            if (raw) setProfileLines(raw.split('\n'))
        },
    })

    const getValue = useCallback(
        (index) => {
            if (!profileLines.length) return 'In Progress...'
            const line = profileLines[index]
            const value = line?.split(': ')[1]
            return value ?? 'No Data'
        },
        [profileLines],
    )

    const renderProfileContent = useCallback(
        (dataIndex) => {
            const value = getValue(dataIndex)
            const list = parseValueToList(value)
            if (list.length > 1) {
                return (
                    <ul className="small mb-0 ps-3" style={{ listStyleType: 'disc', listStylePosition: 'outside' }}>
                        {list.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>
                )
            }
            return <p className="small mb-0">{value}</p>
        },
        [getValue],
    )

    if (campaign.loading) return <CubeLoader size="sm" />

    return (
        <div className="card card-thumbnail py-4 px-3">
            <div className="card-header mb-4 px-1 py-0">
                <h6 className="card-title">Generative AI Audience Profile</h6>
            </div>
            <div className="card-body p-0">
                <div className="row g-3">
                    {PROFILE_SECTIONS.map(({ title, dataIndex, Icon, iconBgColor }) => (
                        <div key={dataIndex} className="col-md-6 col-xl-4">
                            <ProfileCard title={title} Icon={Icon} iconBgColor={iconBgColor}>
                                {renderProfileContent(dataIndex)}
                            </ProfileCard>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default AudienceProfileReport
